import { useLocationTypeAddressObserver } from "@app/components/inspection-form/LocationTypeAddressObserver.jsx"
import { useContactPersonObserver } from "@app/components/inspection-form/ContactPersonObserver.jsx"
import { useStandardPsaObserver } from "@app/components/inspection-form/StandardPsaObserver.jsx"
import { useCustomerObserver } from "@app/components/inspection-form/CustomerObserver.jsx"
import { useJobObserver } from "@app/components/inspection-form/JobObserver.jsx"
import { useEffect } from "react"
import { useDangerListObserver } from "@app/components/inspection-form/DangerListObserver.jsx"
import { useTypicalRisksObserver } from "@app/components/inspection-form/TypicalRisksObserver.jsx"
import { useQualificationObserver } from "@app/components/inspection-form/QualificationObserver.jsx"
import { useWorkplaceObserver } from "@app/components/inspection-form/WorkplaceObserver.jsx"
import { useEquipmentObserver } from "@app/components/inspection-form/EquipmentObserver.jsx"

const InspectionFormObserver = ({ currentFieldsets, setCurrentFieldsets }) => {
	let res
	res = useCustomerObserver(currentFieldsets)
	res = useLocationTypeAddressObserver(res.fieldsets)
	res = useContactPersonObserver(res.fieldsets)
	res = useStandardPsaObserver(res.fieldsets)
	res = useJobObserver(res.fieldsets)
	res = useQualificationObserver(res.fieldsets)
	res = useDangerListObserver(res.fieldsets)
	res = useTypicalRisksObserver(res.fieldsets)
	res = useWorkplaceObserver(res.fieldsets)
	res = useEquipmentObserver(res.fieldsets)

	useEffect(() => {
		if (res.fieldsets !== currentFieldsets && JSON.stringify(res.fieldsets) !== JSON.stringify(currentFieldsets)) {
			setCurrentFieldsets(res.fieldsets)
		}
	}, [res.fieldsets])

	return null
}

export default InspectionFormObserver